import styled from '@emotion/styled';
import React from 'react';

import { Tooltip } from '../../tooltip';

type Props = {
  className?: string,
  dataTest?: string,
  fill?: string,
  mode?: 'light' | 'dark',
  name?: string,
};

export const createTooltipIcon = (Path: React.Node, viewBox: string) => {
  return ({ className, dataTest, fill, mode, name }: Props) => {
    return (
      <Tooltip content={name} mode={mode}>
        <SVG className={className} data-test={dataTest} fill={fill} viewBox={viewBox}>
          <Path fill={fill} />
        </SVG>
      </Tooltip>
    );
  };
};

const SVG = styled.svg`
  width: 100%;
  height: 1em;
  font-size: inherit;
`;
